import React from 'react';
import { Box, Table, TableBody, TableCell, TableContainer, TableHead, TableRow, Grid, Typography } from '@material-ui/core';


const GoodsReceivedNotePDF = React.forwardRef(({ grn, grnType }, ref) => {
  if (!grn) return null;

  const PO = 2; 
  const DGRN = 1;
  const DPO = 3;

  const groupName = grn.groupName || 'N/A';
  const estateName = grn.factoryName || grn.estateName || 'N/A';
  const issueNumber = grn.grnNumber || grn.issueNumber || 'N/A';
  const issuedDate = grn.receivedDate ? new Date(grn.receivedDate).toLocaleDateString('en-GB') : 'N/A';
  const issuedTo = grn.supplierName || grn.issuedTo || 'N/A';
  const orderNumber = grn.poNumber || grn.orderNumber || 'N/A';
  const requisitionNumber = grn.requisitionNumber || 'N/A';
  const warehouseName = grn.warehouseName || 'N/A';
  const quotationNumber = grn.quotationNumber || 'N/A';

  const formatNumber = (num, decimals = 2) => {
    const numericValue = Number(num);
    if (Number.isNaN(numericValue)) {
      return decimals > 0 ? `0.${'0'.repeat(decimals)}` : '0';
    }
    const fixedValue = numericValue.toFixed(decimals);
    const [integerPart, decimalPart = ''] = fixedValue.split('.');
    const formattedInteger = integerPart.replace(/\B(?=(\d{3})+(?!\d))/g, ',');
    return decimals > 0 ? `${formattedInteger}.${decimalPart}` : formattedInteger;
  };

  const getGRNTypeTitle = () => {
    switch (grnType) {
      case PO:
        return 'Goods Received Note - Purchase Order';
      case DGRN:
        return 'Goods Received Note - Direct GRN';
      case DPO:
        return 'Goods Received Note - Direct Purchase Order';
      default:
        return 'Goods Received Note';
    }
  };

  return (
    <div ref={ref} style={{ background: 'white', minHeight: '100vh', padding: 24, fontFamily: 'Arial' }}>
      <Box textAlign="center" mb={2}>
        <Typography variant="h4" style={{ margin: 0, fontWeight: 'bold' }}>{groupName}</Typography>
        <Typography variant="h6" style={{ fontWeight: 'bold', marginTop: 8 }}>{estateName}</Typography>
        <Typography variant="h6" style={{ fontWeight: 'bold', marginTop: 8 }}>{getGRNTypeTitle()}</Typography>
      </Box>
      <hr style={{ border: '1px solid #000', marginBottom: 16 }} />
      
      {/* Header Information */}
      <Grid container spacing={2} style={{ fontSize: 13, marginBottom: 16 }}>
        <Grid item xs={6}>
          <strong>GRN No:</strong> {issueNumber}
        </Grid>
        <Grid item xs={6} style={{ textAlign: 'right' }}>
          <strong>Date:</strong> {issuedDate}
        </Grid>
        <Grid item xs={6}>
          <strong>Supplier:</strong> {issuedTo}
        </Grid>
        {grnType !== DGRN && (
          <Grid item xs={6} style={{ textAlign: 'right' }}>
            <strong>{grnType === DPO ? 'DPO No' : 'PO No'}:</strong> {orderNumber}
          </Grid>
        )}
        {grnType !== DPO && (
          <>
            <Grid item xs={6}>
              <strong>Requisition No:</strong> {requisitionNumber}
            </Grid>
            <Grid item xs={6} style={{ textAlign: 'right' }}>
              <strong>Warehouse:</strong> {warehouseName}
            </Grid>
          </>
        )}
        {grnType === PO && (
          <Grid item xs={12}>
            <strong>Quotation No:</strong> {quotationNumber}
          </Grid>
        )}
      </Grid>

      {/* Table Content */}
      <TableContainer style={{ marginBottom: 16 }}>
        <Table size="small" style={{ border: '1px solid #000' }}>
          <TableHead>
            <TableRow style={{ backgroundColor: '#f5f5f5' }}>
              <TableCell style={{ border: '1px solid #000', fontWeight: 'bold', fontSize: 12 }}>SKU Code</TableCell>
              <TableCell style={{ border: '1px solid #000', fontWeight: 'bold', fontSize: 12 }}>SKU Name</TableCell>
              {grnType !== DPO && (
                <TableCell align="right" style={{ border: '1px solid #000', fontWeight: 'bold', fontSize: 12 }}>Requisition Qty</TableCell>
              )}
              <TableCell align="right" style={{ border: '1px solid #000', fontWeight: 'bold', fontSize: 12 }}>Requested Qty</TableCell>
              {grnType !== DPO && (
                <TableCell align="right" style={{ border: '1px solid #000', fontWeight: 'bold', fontSize: 12 }}>Received Qty</TableCell>
              )}
              {grnType !== DGRN && (
                <>
                  <TableCell align="right" style={{ border: '1px solid #000', fontWeight: 'bold', fontSize: 12 }}>Unit Price</TableCell>
                  {grnType === PO && (
                    <TableCell align="right" style={{ border: '1px solid #000', fontWeight: 'bold', fontSize: 12 }}>Discount</TableCell>
                  )}
                  <TableCell align="right" style={{ border: '1px solid #000', fontWeight: 'bold', fontSize: 12 }}>Net Amount</TableCell>
                </>
              )}
              {/* <TableCell style={{ border: '1px solid #000', fontWeight: 'bold', fontSize: 12 }}>Status</TableCell> */}
            </TableRow>
          </TableHead>
          <TableBody>
            <TableRow>
              <TableCell style={{ border: '1px solid #000', fontSize: 11 }}>{grn.skuMasterCode || '-'}</TableCell>
              <TableCell style={{ border: '1px solid #000', fontSize: 11 }}>{grn.skuMasterName || '-'}</TableCell>
              {grnType !== DPO && (
                <TableCell align="right" style={{ border: '1px solid #000', fontSize: 11 }}>{formatNumber(grn.receivedQty, 2)}</TableCell>
              )}
              <TableCell align="right" style={{ border: '1px solid #000', fontSize: 11 }}>{formatNumber(grn.poQty, 2)}</TableCell>
              {grnType !== DPO && (
                <TableCell align="right" style={{ border: '1px solid #000', fontSize: 11 }}>{formatNumber(grn.receivedQty, 2)}</TableCell>
              )}
              {grnType !== DGRN && (
                <>
                  <TableCell align="right" style={{ border: '1px solid #000', fontSize: 11 }}>{formatNumber(grn.unitPrice, 2)}</TableCell>
                  {grnType === PO && (
                    <TableCell align="right" style={{ border: '1px solid #000', fontSize: 11 }}>{formatNumber(grn.discountAmount, 2)}</TableCell>
                  )}
                  <TableCell align="right" style={{ border: '1px solid #000', fontSize: 11 }}>{formatNumber(grn.netAmount, 2)}</TableCell>
                </>
              )}
              {/* <TableCell style={{ border: '1px solid #000', fontSize: 11 }}>{grn.status || 'Pending'}</TableCell> */}
            </TableRow>
          </TableBody>
        </Table>
      </TableContainer>

      {/* Footer Section */}
      <Box mb={2}>
        <Typography variant="body2" style={{ fontWeight: 'bold', marginBottom: 8 }}>Remarks:</Typography>
        <Box style={{ border: '1px solid #ccc', minHeight: 50, padding: 8 }}></Box>
      </Box>

      <Grid container style={{ fontSize: 12, marginTop: 32 }}>
        <Grid item xs={4} style={{ textAlign: 'center' }}>
          <div style={{ borderTop: '1px solid #000', paddingTop: 4, marginTop: 40 }}>Prepared By</div>
        </Grid>
        <Grid item xs={4} style={{ textAlign: 'center' }}>
          <div style={{ borderTop: '1px solid #000', paddingTop: 4, marginTop: 40 }}>Checked By</div>
        </Grid>
        <Grid item xs={4} style={{ textAlign: 'center' }}>
          <div style={{ borderTop: '1px solid #000', paddingTop: 4, marginTop: 40 }}>Approved By</div>
        </Grid>
      </Grid>

      <div style={{ fontSize: 10, textAlign: 'right', marginTop: 32 }}>Solution Provided by Agrithmics (Pvt) Ltd.</div>
    </div>
  );
});

export default GoodsReceivedNotePDF;
